import * as React from 'react';

import green from '@material-ui/core/colors/green';
import purple from '@material-ui/core/colors/purple';
import CssBaseline from '@material-ui/core/CssBaseline';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import withStyles from '@material-ui/core/styles/withStyles';

import { styles } from './style';

// A theme with custom primary and secondary color.
// It's optional.
const theme = createMuiTheme({
  palette: {
    primary: purple,
    secondary: green,
  },
  typography: {
    useNextVariants: true,
  },
});

export function withRoot<P extends any>(Component: React.ComponentType<P>) {
  return function WithRoot(props: P) {
    // MuiThemeProvider makes the theme available down the React tree
    // thanks to React context.
    return (
      <MuiThemeProvider theme={theme}>
        {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
        <CssBaseline />
        <Component {...props} />
      </MuiThemeProvider>
    );
  }
}

export function withRootStyles<P extends any>(Component: React.ComponentType<P>) {
  return withRoot(withStyles(styles)(Component));
}

export function withDefaultStyles<P extends any>(Component: React.ComponentType<P>) {
  return withStyles(styles)(Component);
}




// WEBPACK FOOTER //
// ./src/utils/material-ui/hoc.tsx